import React, { createContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { STAFF_AUG_REPORT } from '../Constants/strings';

export const StaffAugmentationReportContext = createContext();

export const StaffAugmentationReportProvider = ({ children }) => {
  const [tableState, setTableState] = useState(() => {
    return Object.values(STAFF_AUG_REPORT).reduce((acc, table) => {
      acc[table] = false;
      return acc;
    }, {});
  });

  const [expandAll, setExpandAll] = useState(false);
  const expandAllHandler = () => {
    const newExpandState = !expandAll;
    setExpandAll(newExpandState);
    setTableState((prevState) => {
      const newState = {};
      for (const key in prevState) {
        newState[key] = newExpandState;
      }
      return newState;
    });
  };

  const expandIndividual = (tableName) => {
    if (!Object.values(STAFF_AUG_REPORT).includes(tableName)) return;
    setTableState((prev) => {
      const newState = {
        ...prev,
        [tableName]: !prev[tableName],
      };
      const checkAllExpandedState = Object.values(newState).every(
        (state) => state,
      );
      setExpandAll(checkAllExpandedState);
      return newState;
    });
  };

  const value = useMemo(
    () => ({
      allExpanded: expandAll,
      expandAllHandler,
      expandIndividual,
      accordionState: tableState,
    }),
    [expandAll, tableState],
  );
  return (
    <StaffAugmentationReportContext.Provider value={value}>
      {children}
    </StaffAugmentationReportContext.Provider>
  );
};

StaffAugmentationReportProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
